import { useStores } from 'src/contexts/stores';

export default function usePusher() {
  const { pusher } = useStores();

  return pusher;
}
